import type { SVGProps } from 'react';

const SvgEventMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M17.7 6.4C18.3627 6.4 18.9 5.86274 18.9 5.2C18.9 4.53726 18.3627 4 17.7 4C17.0373 4 16.5 4.53726 16.5 5.2C16.5 5.86274 17.0373 6.4 17.7 6.4Z'
      stroke='currentColor'
      strokeWidth={1.333}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17.8271 10.3724L19.5088 8.69995L21.1905 10.3724L19.5088 12.0448L17.8271 10.3724Z'
      stroke='currentColor'
      strokeWidth={1.333}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.7002 3V5.57258'
      stroke='currentColor'
      strokeWidth={1.333}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9 6L18 14.7L4.1016 20.5373C3.69251 20.7091 3.27896 20.3025 3.44374 19.8906L9 6Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinejoin='round'
    />
    <path d='M7.5 10.2998L17.5 14.2998' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path d='M13.403 16.6612L6.02734 13.7109' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path d='M8.32758 18.7311L4.69434 17.2778' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
  </svg>
);
export default SvgEventMd;
